import { ATTACHMENT_TYPE } from "@home-health-notify/domain";
import { useMediaUrlWithState } from "hhn-commons";
import { useEffect } from "react";

const DocumentPreview = ({
  url,
  onSetDocUrl,
  docType,
  onAutoOpen,
  onError,
}: {
  url: string;
  onSetDocUrl: (url: string) => void;
  docType: ATTACHMENT_TYPE;
  onAutoOpen?: () => void;
  onError?: () => void;
}) => {
  const mediaState = useMediaUrlWithState(url);
  const signedUrl = mediaState.data?.signedUrl;

  useEffect(() => {
    if (!signedUrl) return;

    onSetDocUrl(signedUrl);

    setTimeout(() => {
      let openUrl = signedUrl;
      const encoded = encodeURIComponent(signedUrl);

      if (docType !== ATTACHMENT_TYPE.PDF) {
        openUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encoded}`;
      }

      const newTab = window.open(openUrl, "_blank", "noopener,noreferrer");
      if (newTab) newTab.opener = null;
      if (onAutoOpen) onAutoOpen();
    }, 200);
  }, [signedUrl, docType, onSetDocUrl, onAutoOpen]);

  useEffect(() => {
    if (mediaState.error && onError) {
      onError();
    }
  }, [mediaState.error, onError]);

  return null;
};

export default DocumentPreview;
